import { render, staticRenderFns } from "./estado-en-senasa.vue?vue&type=template&id=47782fa8&"
import script from "./estado-en-senasa.vue?vue&type=script&lang=ts&"
export * from "./estado-en-senasa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports